import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Button, DialogContentText } from '@mui/material';

import OperationForm from './OperationForm';

function toPayload(v) {
  return {
    fast_burst_threshold: Number(v.fast_burst_threshold),
    fast_burst_max_alerts: Number(v.fast_burst_max_alerts),
    fast_burst_idle_samples: Number(v.fast_burst_idle_samples),
    fast_burst_test_count: Number(v.fast_burst_test_count),
  };
}

export default function ConfSetFastBurst(props, context) {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);

  const handleFormSubmit = (data) => {
    setValues(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setValues(null);
  };

  const handleConfirm = () => {
    if (values) {
      props.updateConfig(toPayload(values));
    }
    handleClose();
  };

  return (
    <>
      <OperationForm
        stacked
        enable={props.enable}
        fields={props.fields}
        onSubmit={handleFormSubmit}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogContent>
          <DialogContentText
            style={{ fontSize: 'large', color: 'black', textAlign: 'center' }}
          >
            {context.t(
              'you_are_about_to_take_a_significant_action_on_num_devices',
              { num: props.countSelected }
            )}
            <br />
            <span
              style={{ fontSize: 'medium', color: '#606060', display: 'block' }}
            >
              {context.t('confirm_updating_fast_burst_config')}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {context.t('cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {context.t('continue')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfSetFastBurst.propTypes = {
  enable: PropTypes.bool,
  countSelected: PropTypes.number,
  fields: PropTypes.array,
  updateConfig: PropTypes.func.isRequired,
};

ConfSetFastBurst.defaultProps = {
  enable: false,
  countSelected: 0,
  fields: [],
};

ConfSetFastBurst.contextTypes = {
  t: PropTypes.func.isRequired,
};
